export enum ENTITIES {
  CELL_TYPE = "cell-type",
  COVERAGE = "coverage",
  CYTOBAND = "cytoband",
}
